module.exports = __webpack_public_path__ + "static/media/ic-arrow-left-white.f8ad3bed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-arrow-left-white.svg
// module id = 592
// module chunks = 14